import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LuSearch } from "react-icons/lu";
import { User, Settings, Lock, LogOut } from "react-feather";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase/firebase";

import logo_light from "../assets/images/logo-light.png";
import logo_icon_40 from "../assets/images/logo-icon-40.png";
import logo_icon_40_white from "../assets/images/logo-icon-40-white.png";
import logo_dark from "../assets/images/logo-dark.png";
import logo_4 from "../assets/images/logo4.png";
import image from "../assets/images/team/05.jpg";

export default function Navbar(props) {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { navClass, topnavClass, isContainerFluid } = props;
  const [user] = useAuthState(auth);

  const isLoggedIn = !!user;

  useEffect(() => {
    // Handle scroll events
    const handleScroll = () => {
      const navbar = document.getElementById("topnav");
      const pageTitle = document.getElementById("pageTitle");

      if (window.scrollY >= 50) {
        navbar?.classList.add("nav-sticky");
        pageTitle && (pageTitle.style.color = "black");
      } else {
        navbar?.classList.remove("nav-sticky");
        pageTitle && (pageTitle.style.color = "white");
      }

      const backToTopButton = document.getElementById("back-to-top");
      if (backToTopButton) {
        if (window.scrollY > 500) {
          backToTopButton.classList.remove("hidden");
          backToTopButton.classList.add("flex");
        } else {
          backToTopButton.classList.remove("flex");
          backToTopButton.classList.add("hidden");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Activate menu on initial load
    activateMenu();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
    activateSubmenu();
  };

  const activateSubmenu = () => {
    const navigation = document.getElementById("navigation");
    if (navigation) {
      const links = navigation.getElementsByTagName("a");
      Array.from(links).forEach(link =>
        link.addEventListener("click", event => {
          const submenu = event.target.nextElementSibling?.nextElementSibling;
          if (submenu) submenu.classList.toggle("open");
        })
      );
    }
  };

  const activateMenu = () => {
    const menuItems = document.getElementsByClassName("sub-menu-item");
    let activeItem = null;

    Array.from(menuItems).forEach(item => {
      if (item.href === window.location.href) {
        activeItem = item;
      }
    });

    if (activeItem) {
      activeItem.classList.add("active");
      const immediateParent = getClosest(activeItem, "li");
      immediateParent && immediateParent.classList.add("active");

      let parent = getClosest(immediateParent, ".child-menu-item") || immediateParent;
      parent && parent.classList.add("active");

      const topParent = getClosest(parent, ".parent-parent-menu-item");
      topParent && topParent.classList.add("active");
    }
  };

  const getClosest = (elem, selector) => {
    while (elem && elem !== document) {
      if (elem.matches(selector)) return elem;
      elem = elem.parentNode;
    }
    return null;
  };

  return (
    <nav id="topnav" className={`defaultscroll is-sticky ${topnavClass}`}>
      <div className={isContainerFluid ? "container-fluid md:px-8 px-3" : "container"}>
        <Link className="logo flex flex-row gap-1 items-center" to="/">
          <div>
            <div className="block sm:hidden">
              <img src={logo_4} className="h-10" alt="Logo" />
            </div>
            <div className="sm:block hidden">
              <img src={logo_4} className="h-20 dark:inline-block" alt="Logo" />
            </div>
          </div>
          <div className="flex flex-col items-start text-black dark:text-white">
            <h1 id="pageTitle">PUNJAB GHAR GHAR ROZGAR</h1>
          </div>
        </Link>

        <div className="menu-extras">
          <button
            onClick={toggleMenu}
            className="menu-item navbar-toggle"
            id="isToggle"
          >
            <div className="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>

        {/* Login Button */}
        <ul className="buy-button list-none mb-0">
          {!isLoggedIn && (
            <li className="inline-block mb-0">
              <Link
                to="/login"
                className="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 dark:border-emerald-600 text-white rounded-full"
              >
                Login
              </Link>
            </li>
          )}

          {isLoggedIn && (
            <li className="dropdown inline-block relative ps-1">
              <button
                onClick={() => setDropdownOpen(!isDropdownOpen)}
                className="dropdown-toggle btn btn-icon rounded-full bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white"
              >
                <img src={image} className="rounded-full" alt="User" />
              </button>

              <div
                className={`dropdown-menu absolute right-0 mt-4 z-10 w-44 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 ${
                  isDropdownOpen ? "block" : "hidden"
                }`}
              >
                <ul className="py-2 text-start">
                  <li>
                    <Link to="/candidate-profile" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-emerald-600 dark:hover:text-white">
                      <User className="h-4 w-4 me-2" /> Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/candidate-profile-setting" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-emerald-600 dark:hover:text-white">
                      <Settings className="h-4 w-4 me-2" /> Settings
                    </Link>
                  </li>
                  <li className="border-t border-gray-100 dark:border-gray-800 my-2"></li>
                  <li>
                    <Link to="/lock-screen" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-emerald-600 dark:hover:text-white">
                      <Lock className="h-4 w-4 me-2" /> Lockscreen
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-emerald-600 dark:hover:text-white">
                      <LogOut className="h-4 w-4 me-2" /> Logout
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          )}
        </ul>

        <div id="navigation" className={`${isMenuOpen ? "hidden" : "block"}`}>
          <ul className={`navigation-menu ${navClass}`}>
            <li className="parent-menu-item">
              <Link to="/">Home</Link>
            </li>
            <li className="parent-menu-item">
              <Link to="/aboutus">About Us</Link>
            </li>
            <li>
              <Link to="/contact" className="sub-menu-item">Contact</Link>
            </li>
            <li className="has-submenu parent-parent-menu-item">
              <Link to="#">Help Center</Link>
              <span className="menu-arrow"></span>
              <ul className="submenu">
                <li>
                  <Link to="/helpcenter-faqs" className="sub-menu-item">FAQs</Link>
                </li>
                <li className="parent-menu-item">
                  <Link to="/services">Services</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
